import { useState } from 'react';
import { Button } from '@artosera/ui';
import { useTranslation } from 'react-i18next';
import { reserveApi, useCaisses, useMutationReserve } from '../../api/reserve.js';
import { estApiError } from '../../api/errors.js';
import { galerieALaction } from '../../auth/sujet.js';
import { useShellContext } from '../shell/context.js';
import type { MouvementPresente } from '../../api/mouvements.js';
import styles from './InventairePage.module.css';

export function CaissesMouvement({ mouvement }: { mouvement: MouvementPresente }) {
  const { t } = useTranslation(['regie', 'commun']);
  const { galerieSlug, galerie } = useShellContext();
  const liste = useCaisses(galerieSlug, { parPage: 200 });
  const [selection, setSelection] = useState(mouvement.caisseIds ?? []);
  const mutation = useMutationReserve(galerieSlug, (caisseIds: string[], appel) =>
    reserveApi.caissesMouvement(galerieSlug, mouvement.id, caisseIds, appel),
  );
  const ecrit =
    galerieALaction(galerie, 'inventaire:write') && ['prevu', 'en_cours'].includes(mouvement.etat);
  return (
    <section className={styles.panneau}>
      <h2>{t('regie:inventaire.caissesCitees')}</h2>
      {liste.isError && <p role="alert">{t('commun:erreurReseau')}</p>}
      <fieldset>
        <legend>{t('regie:inventaire.caisses')}</legend>
        {liste.data?.caisses
          .filter((c) => ecrit || selection.includes(c.id))
          .map((c) => (
            <label className={styles.case} key={c.id}>
              <input
                type="checkbox"
                disabled={!ecrit || mutation.isPending}
                checked={selection.includes(c.id)}
                onChange={(e) =>
                  setSelection(
                    e.target.checked ? [...selection, c.id] : selection.filter((id) => id !== c.id),
                  )
                }
              />
              {c.numero}
            </label>
          ))}
      </fieldset>
      {ecrit && (
        <Button disabled={mutation.isPending} onClick={() => mutation.mutate(selection)}>
          {t('regie:inventaire.confirmer')}
        </Button>
      )}
      {mutation.error && (
        <p role="alert">
          {estApiError(mutation.error) ? mutation.error.message : t('commun:erreurReseau')}
        </p>
      )}
    </section>
  );
}
